export enum WaitingPeriodPopupTypeEnum {
	SUBMIT = "submit",
	GAME = "game",
}
